import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { ordersClient } from "@core/clients";
import { CreateOrderData, TOrder } from "@core/types";
import { queryClient } from "../../config/query-client";

const useCreateOrderMutation = (options?: UseMutationOptions<Partial<TOrder>, any, CreateOrderData>) => {
  return useMutation<Partial<TOrder>, any, CreateOrderData>(
    ["order", "create"],
    async (orderData: CreateOrderData) => {
      return ordersClient.createOrder(orderData);
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: ["orders"] });
        if (data.rewardPoints) {
          queryClient.invalidateQueries({ queryKey: ["get-profile", data.customer?.id] });
        }
        options?.onSuccess?.(data, variables, context);
      },
      onError: (error, variables, context) => {
        options?.onError?.(error, variables, context);
      },
    },
  );
};

export default useCreateOrderMutation;
